import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { createHitomi } from '@/repository/hitomi';
import { Hitomi } from '@/model/hitomi';
import { useStore } from 'vuex';
import { HttpStatusCode } from 'axios';
import HitomiInformation from '@/components/disposable/HitomiInformation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateHitomiView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isLoading = ref(false);
const hitomi = ref<Hitomi>(initialize());

function initialize(): Hitomi {
	return {
		hitomiTitle: '',
		hitomiImageURL: '',
		hitomiLink: '',
		hitomiArtists: [],
		hitomiGroups: [],
		hitomiTags: [],
		isFavorite: false
	};
}

async function saveHitomi(isRedirect: boolean, data: Hitomi) {
	hitomi.value = data;
	try {
		isLoading.value = true;
		if (hitomi.value) {
			// DISABLED UPLOAD
			const res = await createHitomi(hitomi.value);
			if (res.status === HttpStatusCode.Ok) {
				store.dispatch('alert', { type: 'success', message: 'create new hitomi successfully!' });
				if (isRedirect) {
					isLoading.value = false;
					await router.push({ name: 'Hitomi' });
					return;
				}
				hitomi.value = initialize();
			} else if (res.status === HttpStatusCode.BadRequest) {
				throw res.error?.error;
			} else if (res.status === HttpStatusCode.Conflict) {
				throw Error('this hitomi is already exists!');
			}
		}
		throw Error('image is required');
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(HitomiInformation, {
      hitomi: hitomi.value,
      "is-loading": isLoading.value,
      onReset: _cache[0] || (_cache[0] = () => (hitomi.value = initialize())),
      onSubmit: saveHitomi
    }, null, 8, ["hitomi", "is-loading"])
  ]))
}
}

})